(async function () {
  const root = document.currentScript.closest('.petso-aquarium-products');
  if (!root || !root.dataset.catalogUrl) return;
  const tabBar = root.querySelector('.petso-aquarium-tabs');
  const tabList = root.querySelector('.petso-aquarium-tabs__list');
  const tabPlaceholder = root.querySelector('.petso-aquarium-tab-placeholder');
  const filterBar = root.querySelector('.petso-aquarium-filterbar');
  function installThresholdStickyTabs() {
    if (!tabBar || !tabPlaceholder || tabBar.dataset.stickyReady === 'true') return;
    tabBar.dataset.stickyReady = 'true';
    let ticking = false;
    function headerOffset() {
      const header = document.querySelector('sticky-header, .header-wrapper, header');
      return header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    }
    function update() {
      ticking = false;
      const topOffset = headerOffset();
      const anchor = tabBar.classList.contains('is-fixed') ? tabPlaceholder : tabBar;
      const shouldFix = anchor.getBoundingClientRect().top <= topOffset;
      // Aquarium: only the Shop by area category block floats. The filter and sort controls remain in normal document flow.
      tabBar.style.setProperty('--petso-aquarium-tab-top', topOffset + 'px');
      tabBar.classList.toggle('is-fixed', shouldFix);
      filterBar?.classList.remove('is-mobile-fixed');
      filterBar?.style.removeProperty('--petso-aquarium-filter-top');
      tabPlaceholder.classList.toggle('is-active', shouldFix);
      tabPlaceholder.style.height = shouldFix ? tabBar.offsetHeight + 'px' : '0px';
    }
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive:true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  installThresholdStickyTabs();
  const grid = root.querySelector('.petso-aquarium-product-grid');
  const count = root.querySelector('.petso-aquarium-count');
  const pagination = root.querySelector('.petso-aquarium-pagination');
  const availability = root.querySelector('[data-filter="availability"]');
  const brand = root.querySelector('[data-filter="brand"]');
  const type = root.querySelector('[data-filter="type"]');
  const price = root.querySelector('[data-filter="price"]');
  const sort = root.querySelector('[data-filter="sort"]');
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  const pageSize = 24;
  const escape = value => String(value || '').replace(/[&<>"']/g, character => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[character]));
  const choices = items => [...new Set(items.filter(Boolean))].sort((a, b) => a.localeCompare(b));
  const response = await fetch(root.dataset.catalogUrl, { cache: 'no-store' });
  if (!response.ok) throw new Error('Aquarium catalogue could not be loaded');
  const catalog = await response.json();
  const categoryOrder = catalog.taxonomy.map(item => item.id);
  let selectedCategory = 'all';
  let currentPage = 1;

  function fill(container, values, label) {
    container.innerHTML = '';
    const all = document.createElement('label');
    all.innerHTML = '<input type="radio" name="' + container.dataset.filter + '" value="all" checked> ' + label;
    container.append(all);
    values.forEach(value => {
      const option = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'radio'; input.name = container.dataset.filter; input.value = value;
      option.append(input, document.createTextNode(' ' + value)); container.append(option);
    });
  }
  function selected(box) { return box.querySelector('input:checked')?.value || 'all'; }
  function matchesPrice(product, selectedPrice) {
    const value = Number(product.minPrice || 0);
    return selectedPrice === 'all' || (selectedPrice === 'under_50' && value < 50) || (selectedPrice === '50_150' && value >= 50 && value < 150) || (selectedPrice === '150_500' && value >= 150 && value < 500) || (selectedPrice === 'over_500' && value >= 500);
  }
  function priorityCompare(a, b) {
    const inStock = Number(Boolean(b.availableForSale)) - Number(Boolean(a.availableForSale));
    if (inStock) return inStock;
    if (selectedCategory === 'all') {
      const category = categoryOrder.indexOf(a.featureIds?.[0]) - categoryOrder.indexOf(b.featureIds?.[0]);
      if (category) return category;
    }
    const recency = new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime();
    if (recency) return recency;
    return a.title.localeCompare(b.title);
  }
  function card(product) {
    const article = document.createElement('article');
    article.className = 'petso-aquarium-card' + (product.availableForSale ? '' : ' petso-aquarium-card--soldout');
    const target = escape(product.onlineStoreUrl || ('/products/' + product.handle));
    const discount = product.availableForSale ? Math.round(Number(product.discountPercent || 0)) : 0;
    const discountMarkup = discount ? `<span class="petso-aquarium-card__discount">UP TO ${discount}% OFF</span>` : '';
    article.innerHTML = `<a class="petso-aquarium-card__media" href="${target}"><img src="${escape(product.featuredImage)}" alt="${escape(product.title)}" loading="lazy">${discountMarkup}</a><div class="petso-aquarium-card__body"><div class="petso-aquarium-card__category">${escape(product.category)}</div><h3>${escape(product.title)}</h3><div class="petso-aquarium-card__price">${money.format(Number(product.minPrice || 0))}</div><div class="petso-aquarium-card__status">${product.availableForSale ? '' : 'Sold out'}</div><a class="petso-aquarium-card__cta" href="${target}">${product.availableForSale ? 'View product' : 'View details'}</a></div>`;
    return article;
  }
  function filteredProducts() {
    const current = { availability:selected(availability), brand:selected(brand), type:selected(type), price:selected(price), sort:sort.value };
    let products = catalog.products.filter(product =>
      (selectedCategory === 'all' || (product.featureIds || []).includes(selectedCategory)) &&
      (current.availability === 'all' || (current.availability === 'in_stock' ? product.availableForSale : !product.availableForSale)) &&
      (current.brand === 'all' || product.vendor === current.brand) &&
      (current.type === 'all' || product.productType === current.type) && matchesPrice(product, current.price)
    );
    if (current.sort === 'priority') products = [...products].sort(priorityCompare);
    if (current.sort === 'price_low') products = [...products].sort((a,b) => Number(Boolean(b.availableForSale)) - Number(Boolean(a.availableForSale)) || Number(a.minPrice) - Number(b.minPrice) || a.title.localeCompare(b.title));
    if (current.sort === 'price_high') products = [...products].sort((a,b) => Number(Boolean(b.availableForSale)) - Number(Boolean(a.availableForSale)) || Number(b.minPrice) - Number(a.minPrice) || a.title.localeCompare(b.title));
    if (current.sort === 'alpha') products = [...products].sort((a,b) => Number(Boolean(b.availableForSale)) - Number(Boolean(a.availableForSale)) || a.title.localeCompare(b.title));
    return products;
  }
  function pageButton(label, targetPage, options = {}) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'petso-aquarium-pagination__button'; button.textContent = label;
    button.setAttribute('aria-label', options.ariaLabel || label);
    if (options.current) button.setAttribute('aria-current', 'page');
    button.disabled = Boolean(options.disabled);
    button.addEventListener('click', () => {
      if (button.disabled || targetPage === currentPage) return;
      currentPage = targetPage; render();
      grid.scrollIntoView({ behavior:'smooth', block:'start' });
    });
    return button;
  }
  function renderPagination(totalPages) {
    pagination.innerHTML = '';
    if (totalPages <= 1) { pagination.hidden = true; return; }
    pagination.hidden = false;
    pagination.append(pageButton('Previous', currentPage - 1, { ariaLabel:'Previous page', disabled:currentPage === 1 }));
    for (let page = 1; page <= totalPages; page += 1) pagination.append(pageButton(String(page), page, { ariaLabel:'Page ' + page, current:page === currentPage }));
    pagination.append(pageButton('Next', currentPage + 1, { ariaLabel:'Next page', disabled:currentPage === totalPages }));
  }
  function render() {
    const products = filteredProducts();
    const totalPages = Math.max(1, Math.ceil(products.length / pageSize));
    currentPage = Math.min(currentPage, totalPages);
    const visible = products.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    if (!products.length) grid.innerHTML = '<p class="petso-aquarium-empty">' + escape(root.dataset.emptyMessage || 'No products match these filters.') + '</p>';
    visible.forEach(product => grid.append(card(product)));
    grid.setAttribute('aria-busy', 'false');
    count.textContent = products.length ? `${products.length} product${products.length === 1 ? '' : 's'} · Page ${currentPage} of ${totalPages}` : '0 products';
    renderPagination(totalPages);
  }
  function applyCategory(id) {
    selectedCategory = id; currentPage = 1;
    tabList.querySelectorAll('[data-category]').forEach(button => {
      const active = button.dataset.category === id;
      button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    render();
  }
  function buildTabs() {
    tabList.innerHTML = '';
    const makeButton = (id, label, active) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'petso-aquarium-tab' + (active ? ' is-active' : '');
      button.dataset.category = id; button.textContent = label; button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.addEventListener('click', () => applyCategory(id));
      return button;
    };
    tabList.append(makeButton('all', 'All', true));
    catalog.taxonomy.forEach(item => tabList.append(makeButton(item.id, item.label, false)));
  }
  fill(availability, ['in_stock', 'sold_out'], 'All availability');
  fill(brand, choices(catalog.products.map(product => product.vendor)), 'All brands');
  fill(type, choices(catalog.products.map(product => product.productType)), 'All product types');
  fill(price, ['under_50', '50_150', '150_500', 'over_500'], 'All prices');
  root.querySelectorAll('input, select').forEach(control => control.addEventListener('change', () => { currentPage = 1; render(); }));
  buildTabs(); render();
})().catch(error => { console.error('Petso Aquarium catalogue failed:', error); });
